export default "__VITE_ASSET__c63c41bf__"